import React, { useState } from 'react';
import { CircularProgress } from '@mui/material';


const ImageItem = ({ image, onChange, selected }) => {

  const { cdn_url, name } = image;

  const [loading, setLoading] = useState(true);

  return (
    <div className="visual-menu-image position-relative" style={selected ? { border: "2px solid var(--purple6)" } : {}} onClick={e => !loading && onChange(e, image)}>

      <img
        onLoad={() => setLoading(false)}
        style={{ display: loading ? 'none' : 'block' }}
        src={cdn_url}
        alt={name}
      />

      <CircularProgress
        size={20}
        sx={{ display: loading ? 'block' : 'none', position: "absolute" }}
      />
    </div>
  );
};

export default ImageItem;
